export enum BookForSomeoneElseBannerDataHooks {
  BANNER = 'book-for-someone-else-banner',
  PRICING_PLAN_NOTICE = 'book-for-someone-else-banner-pricing-plan',
}
